var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerifiedCaterersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8135 45.272H12.1971C10.054 45.272 8.1496 43.8995 7.47242 41.8677C6.89642 40.1371 8.18333 38.3496 10.0073 38.3496H31.3335",
    stroke: "#383838",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6995 38.3467L10.5905 36.1363C9.99635 24.2763 19.4536 14.334 31.3317 14.334C43.2069 14.334 47.3348 17.6361 52.0015 24.3027",
    stroke: "#383838",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3343 14.3327L31.3335 10",
    stroke: "#383838",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.427 53.3374C46.9603 53.3374 39.2593 47.103 39.2593 40.5798C39.2593 35.5156 43.3627 31.4121 48.427 31.4121C53.491 31.4121 57.5945 35.5156 57.5945 40.5798C57.5945 47.103 49.8934 53.3374 48.427 53.3374Z",
    stroke: "#383838",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0002 40.9691C54.0002 43.913 51.6108 46.3024 48.6648 46.3024C45.7188 46.3024 43.3335 43.913 43.3335 40.9691C43.3335 38.0231 45.7188 35.6357 48.6648 35.6357C51.6108 35.6357 54.0002 38.0231 54.0002 40.9691Z",
    fill: "#26B8E3",
    stroke: "#383838",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedCaterersIcon);
export default __webpack_public_path__ + "static/media/VerifiedCaterersIcon.335291219ae16741604c8f041bd37237.svg";
export { ForwardRef as ReactComponent };